/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreatePickupAddressRequest,
    PickupAddressResponse,
} from '../models';

export interface PickupAddressApiControllerCreatePickupAddressRequest {
    storeId: string;
    createPickupAddressRequest: CreatePickupAddressRequest;
}

export interface PickupAddressApiControllerEditPickupAddressRequest {
    id: string;
    storeId: string;
    createPickupAddressRequest: CreatePickupAddressRequest;
}

export interface PickupAddressApiControllerGetPickupAddressesRequest {
    storeId: string;
}

export interface PickupAddressApiControllerSetDefaultPickupAddressRequest {
    id: string;
    storeId: string;
}

/**
 * 
 */
export class PickupAddressApi extends runtime.BaseAPI {

    /**
     */
    async pickupAddressApiControllerCreatePickupAddressRaw(requestParameters: PickupAddressApiControllerCreatePickupAddressRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling pickupAddressApiControllerCreatePickupAddress.');
        }

        if (requestParameters.createPickupAddressRequest === null || requestParameters.createPickupAddressRequest === undefined) {
            throw new runtime.RequiredError('createPickupAddressRequest','Required parameter requestParameters.createPickupAddressRequest was null or undefined when calling pickupAddressApiControllerCreatePickupAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/pickup-addresses`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createPickupAddressRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pickupAddressApiControllerCreatePickupAddress(requestParameters: PickupAddressApiControllerCreatePickupAddressRequest): Promise<void> {
        await this.pickupAddressApiControllerCreatePickupAddressRaw(requestParameters);
    }

    /**
     */
    async pickupAddressApiControllerEditPickupAddressRaw(requestParameters: PickupAddressApiControllerEditPickupAddressRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling pickupAddressApiControllerEditPickupAddress.');
        }

        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling pickupAddressApiControllerEditPickupAddress.');
        }

        if (requestParameters.createPickupAddressRequest === null || requestParameters.createPickupAddressRequest === undefined) {
            throw new runtime.RequiredError('createPickupAddressRequest','Required parameter requestParameters.createPickupAddressRequest was null or undefined when calling pickupAddressApiControllerEditPickupAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/pickup-addresses/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createPickupAddressRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pickupAddressApiControllerEditPickupAddress(requestParameters: PickupAddressApiControllerEditPickupAddressRequest): Promise<void> {
        await this.pickupAddressApiControllerEditPickupAddressRaw(requestParameters);
    }

    /**
     */
    async pickupAddressApiControllerGetPickupAddressesRaw(requestParameters: PickupAddressApiControllerGetPickupAddressesRequest): Promise<runtime.ApiResponse<Array<PickupAddressResponse>>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling pickupAddressApiControllerGetPickupAddresses.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/pickup-addresses`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async pickupAddressApiControllerGetPickupAddresses(requestParameters: PickupAddressApiControllerGetPickupAddressesRequest): Promise<Array<PickupAddressResponse>> {
        const response = await this.pickupAddressApiControllerGetPickupAddressesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async pickupAddressApiControllerSetDefaultPickupAddressRaw(requestParameters: PickupAddressApiControllerSetDefaultPickupAddressRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling pickupAddressApiControllerSetDefaultPickupAddress.');
        }

        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling pickupAddressApiControllerSetDefaultPickupAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/pickup-addresses/{id}:set-default`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pickupAddressApiControllerSetDefaultPickupAddress(requestParameters: PickupAddressApiControllerSetDefaultPickupAddressRequest): Promise<void> {
        await this.pickupAddressApiControllerSetDefaultPickupAddressRaw(requestParameters);
    }

}
